import useTags from "core/features/tags/hooks/useTags";
import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";
import { useState } from "react";

export interface SelectTagsProps<T = any> extends SelectBaseAntdProps<T> {
  value: any;
  onChange: (v: any) => void;
}

function SelectTags({ value, onChange, ...rest }: SelectTagsProps) {
  const [search, setSearch] = useState<string>();

  const { isLoading, data } = useTags();

  return (
    <SelectBaseAntd
      loading={isLoading}
      size="large"
      placeholder="Tag"
      value={value}
      allowClear={false}
      showSearch
      searchValue={search}
      onSearch={setSearch}
      onChange={onChange}
      optionFilterProp="label"
      options={data?.map((item: any) => ({
        value: item.id,
        label: item.nome,
      }))}
      {...rest}
    />
  );
}

export default SelectTags;
